(function () {
    'use strict';
    var controllerId = 'cndPAziendaSelect';
    angular.module('app').controller(controllerId, ['$scope', 'datacontext', '$uibModalInstance', 'partecipazioneId', 'aziende', 'isSuper', fn_cndPAziendaSelect]);

    function fn_cndPAziendaSelect($scope, datacontext, $uibModalInstance, partecipazioneId, aziende, isSuper) {
        $scope.aziende = aziende;
        $scope.isSuper = isSuper;

        $scope.title = 'Nuovo Partner';
        $scope.record = {};
        $scope.partecipazioneId = partecipazioneId;

        

        $scope.ok = function (isValid) {
            if (isValid) {
                $scope.record.PartecipazioneId = $scope.partecipazioneId;

                var result = addItem($scope.record);
                $uibModalInstance.close(result);
            }
        };

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };

        $scope.changePartner = function (id) {
            getAzienda(id);
        };

        function getAzienda(id) {
            $scope.record = {};
            return datacontext.azienda_get(id).then(function (data) {
                console.info('getAzienda()', data);
                return $scope.record = data;
            });
        }


        function addItem(item) {
            return datacontext.azienda_saveComplete(item).then(function (data) {
                return data;
            });
        }

    }
})();